import { useEffect, useState } from "react";

/**
 * File → 미리보기용 objectURL 생성/해제 훅.
 * 파일이 바뀌면 이전 URL 을 자동으로 revoke 합니다.
 */
export function useObjectUrl(file: File | null): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!file) {
      setUrl(null);
      return;
    }
    const next = URL.createObjectURL(file);
    setUrl(next);
    return () => URL.revokeObjectURL(next);
  }, [file]);

  return url;
}